import { IRootReducerState } from 'state/rootReducer'
import { useDispatch, useSelector } from 'react-redux'
import { getDefaultOrderAccountDetails, getNewDefaultOrderAccount } from 'app/settings/state/DefaultOrderAccount/actions'
import { EmptyUUID } from '@cbgms/base/utils/uuid'
import { useQuery } from '@tanstack/react-query'

export const useDefaultOrderAccount = () => {
  const dispatch = useDispatch()
  const hasLoaded = useSelector<IRootReducerState, boolean>(state => state.settings.defaultOrderAccount.hasLoaded)

  // Use React Query to fetch default order account details
  // This automatically deduplicates requests with the same query key
  const defaultOrderAccountUUID = useSelector<IRootReducerState, string | undefined>(
    state => state.settings.defaultOrderAccount.defaultOrderAccountUUID
  )

  const { data: orderAccountDetails } = useQuery(
    ['order-account-details', defaultOrderAccountUUID, 'with-related'],
    async () => {
      if (!defaultOrderAccountUUID || defaultOrderAccountUUID === EmptyUUID) {
        return undefined
      }
      const { Data } = await dispatch(getDefaultOrderAccountDetails(defaultOrderAccountUUID))
      return Data
    },
    {
      enabled: !!defaultOrderAccountUUID && defaultOrderAccountUUID !== EmptyUUID,
      staleTime: 5 * 60 * 1000 // 5 minutes
    }
  )

  return {
    orderAccount: orderAccountDetails,
    hasLoaded,
    loadDefaultOrderAccount: async () => {
      // Just load the UUID setting - React Query will handle fetching details
      await dispatch(getNewDefaultOrderAccount())
    }
  }
}
